import {
  EyeInvisibleOutlined,
  EyeOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { Button, Checkbox, Form, Modal, Spin, Tag, message } from "antd";
import dayjs from "dayjs";
import { ReactElement, ReactNode, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ApplicationBankCard } from "../../components/Application/ApplicationBankCard/ApplicationBankCard";
import { BankModalList } from "../../components/Application/BankCredit/BankModalList/BankModalList";
import { ButtonGroupStatus } from "../../components/Application/ButtonGroupStatus/ButtonGroupStatus";
import { buttonConfigs } from "../../components/Application/ButtonGroupStatus/ButtonKindGroup";
import { DraftButtons } from "../../components/Application/ButtonGroupStatus/DraftButtons";
import { MatchCompRequest } from "../../components/Application/MatchCompRequest/MatchCompRequest";
import { HocUiModuleCardBanks } from "../../components/Application/WrapperUiModuleData/HocUiModuleCardBanks";
import { BankCheckBoxesList } from "../../components/ApplicationCreate/BankSelection/BankCheckBoxesList/BankCheckBoxesList";
import { BankListInApplicationInfoModal } from "../../components/ApplicationCreate/BankSelection/BankListInApplicationInfoModal/BankListInApplicationInfoModal";
import { DocumentsSignModalButton } from "../../components/DocumentsSignModal/ui/DocumentsSignModalButton";
import { bankStatusesForSign } from "../../constants/pageApplication/bankStatusesForSign";
import { PASSPORT_ID } from "../../constants/passportId";
import { APPLICATION_STATUS_ID } from "../../enums/applicationStatusIdEnum";
import { MATCH_DATA_APPLICATION_RENDER } from "../../enums/matchDataApplicationRender";
import { IConstructorAplicationButton } from "../../interfaces/Constructor/IConstructorAplicationButton";
import {
  useAddApplicationBanksMutation,
  useApplicationBankArchiveMutation,
  useChangeApplicationStatusMutation,
  useEditApplicationMutation,
  useGetApplicationDataQuery,
} from "../../store/api/application.api";
import { useAppDispatch, useAppSelector } from "../../store/reduxHooks";
import { SELECT_IS_NEW_MESSAGE } from "../../store/selectors/applicatoinsSelector";
import { SELECT_PROFILE_ROLE } from "../../store/selectors/profileSelectors";
import {
  SELECT_APPLICATION_BANKS,
  SELECT_APPLICATION_FORM_VALUES,
  SELECT_APPLICATION_STATUS,
  SELECT_DONT_ATTACHED_BANKS,
  SELECT_REQUEST_ALL_DATA,
  SELECT_REQUEST_BANK,
  SELECT_REQUEST_BANK_ID,
  SELECT_REQUEST_DOCUMENTS_COUNT,
  SELECT_REQUEST_MATCH,
} from "../../store/selectors/requestAppSelector";
import {
  ADD_NEW_BANK,
  UP_DATE_APPLICATION_STATUS,
  UP_DATE_IS_NEW_MESSAGE,
  UP_DATE_IS_READ,
} from "../../store/slice/applicationsSlice/applicationsSlice";
import {
  CLEAR_DATA_APPLICATION,
  SET_APPLICATION_DATA,
  SWAP_MATCH_DATA_REQUEST,
  SWAP_MATCH_DATA_REQUEST_BANK_ID,
} from "../../store/slice/requestAppSlise/requestAppSlise";
import { STATUS_APPLICATION, USER } from "../../types/indexTypeEnum";
import {
  UIModuleStikeController,
  UI_ITOModuleSubTitle,
  UI_ITOModuleTitle,
  UI_ModuleTitleCard,
} from "../../UI_ITO/indexUI";
import {
  APPLICATION_BANK_STATUS_KKB,
  BANK_NAME,
} from "../../utils/guards/ApplicationBankStatusGuard/types";
import { Guard } from "../../utils/guards/Guard";
import { plural } from "../../utils/utilities/plural";
import { sortByKey } from "../../utils/utilities/sortByKey";

import classes from "./PageApplication.module.css";

function DocumentCount({ quantity }: { quantity: number }): ReactElement {
  return quantity ? (
    <div className={classes.circle}>
      <div className={classes.documentsNumber}>{quantity}</div>
    </div>
  ) : (
    <></>
  );
}

/**
 * Компонент страницы заявки
 */
export function PageApplication(): ReactElement {
  const MATCH_RENDERS = useAppSelector(SELECT_REQUEST_MATCH);
  const { id } = useParams();
  const navigate = useNavigate();
  const [editApplication, { isSuccess: isSuccessEdit }] =
    useEditApplicationMutation();
  const [addBanks, { isError: addError, isLoading: addBankLoading }] =
    useAddApplicationBanksMutation();
  const {
    isLoading,
    data: application,
    error,
    refetch,
  } = useGetApplicationDataQuery(Number(id));
  const [changeStatus] = useChangeApplicationStatusMutation();
  const dispatch = useAppDispatch();
  const countDoc = useAppSelector(SELECT_REQUEST_DOCUMENTS_COUNT);
  const applicationFormValues = useAppSelector(SELECT_APPLICATION_FORM_VALUES);
  const application_banks = useAppSelector(SELECT_REQUEST_BANK);
  const data = useAppSelector(SELECT_REQUEST_ALL_DATA);
  const bankData = useAppSelector(SELECT_REQUEST_BANK_ID);
  const banks = useAppSelector(SELECT_DONT_ATTACHED_BANKS);
  const role = useAppSelector(SELECT_PROFILE_ROLE);
  const activeBankInfo = useAppSelector(
    (state) => state.requestAppSlise.data.bank,
  );
  const isNewMessage = useAppSelector(SELECT_IS_NEW_MESSAGE(Number(id) ?? 0));
  const preferedBanks = useAppSelector(SELECT_APPLICATION_BANKS);
  const STATUS_TYPE = useAppSelector(
    SELECT_APPLICATION_STATUS,
  ) as STATUS_APPLICATION;
  const [modalVisible, setModalVisible] = useState(false);
  const [titleMatchCompRequest, setTitleMatchCompRequest] = useState<
    string | ReactNode
  >("Основная информация");
  const [activeCard, setActiveCard] = useState("INFO_PURCHASE");
  const [isModalStatus, setIsModalStatus] = useState(false);
  const [changingStatus, setChangingStatus] = useState({
    type: "",
    title: "",
  });
  const [isLoadingArray, setIsLoadingArray] = useState({
    isLoadingEdit: false,
    isLoadingEditAndToInWork: false,
  });
  const [formModal] = Form.useForm();
  const [formChange] = Form.useForm();
  const [formModalAddPreferredBanks] = Form.useForm();
  const { documents } = data;

  const foundDocument = documents?.find(
    (document) => document.type === PASSPORT_ID,
  );
  const isPassportNotIncludes = foundDocument?.document ? false : true;
  const buttonType = useMemo(() => {
    const type = data?.status?.type;
    switch (type) {
      case "in_work":
        return "IN_WORK";
      case "new_application":
        return "NEW_APPLICATION";
      case "rejected":
        return "REJECTED_BANK";
      case "rejected_agent":
        return "REJECTED_CLIENT";
      case "to_rework":
        return "FOR_REVISION";
      case "issued":
        return "ISSUED";
      case "status_offer":
        return "OFFER";
      default:
        return "";
    }
  }, [data]);

  const infoCard = [
    {
      title: "Основная информация",
      documentsCount: 0,
      MATCH_DATA: "INFO_PURCHASE",
    },
    {
      title: "Необходимые документы",
      documentsCount: countDoc,
      text: "Требуется загрузка документов",
      icon: (
        <>
          {(role === USER.AGENT_SIMPLE || role === USER.CLIENT_SIMPLE) && (
            <DocumentCount quantity={countDoc} />
          )}
        </>
      ),
      MATCH_DATA: "DOCUMENT",
    },
    {
      title: "Чат с TatBG",
      documentsCount: 0,
      icon: (
        <>
          {isNewMessage && (
            <div style={{ display: "flex", gap: "4px" }}>
              <MailOutlined style={{ cursor: "pointer", color: "#3c79ff" }} />
              Новое сообщение
            </div>
          )}
        </>
      ),
      MATCH_DATA: "CHAT",
    },
    {
      title: "Банки",
      documentsCount: 0,
      icon: <DocumentCount quantity={countDoc} />,
      MATCH_DATA: "BANK_CREDIT",
    },
  ];

  // обновлять данные при переходе на завку
  useEffect(() => {
    refetch();
  }, [refetch]);

  // открывать вкладку Информация о закупке при открытии новой заявки
  useEffect(() => {
    dispatch(SWAP_MATCH_DATA_REQUEST("INFO_PURCHASE"));
    dispatch(CLEAR_DATA_APPLICATION("CLEAR"));
    setActiveCard("INFO_PURCHASE");
  }, [dispatch, id]);

  // поменять данные при переходе на заявку и пометить заявку как прочитана
  useEffect(() => {
    let action = true;
    if (action) {
      document.body.style.overflow = isLoading ? "hidden" : "auto";
      if (!isLoading && !error && application) {
        dispatch(
          SET_APPLICATION_DATA({
            ...application,
          }),
        );
        dispatch(UP_DATE_IS_READ({ id: Number(id) ?? 0, read: false }));
      } else if (error?.status === 422) {
        navigate("/404");
      }
    }
    return () => {
      action = false;
      dispatch(CLEAR_DATA_APPLICATION("UPDATE"));
    };
  }, [application, error, isLoading]);

  // при редактировании заявки подставить данные в форму
  useEffect(() => {
    const { start_bg_at, finish_bg_at } = applicationFormValues;
    formChange.setFieldsValue({
      ...applicationFormValues,
      start_bg_at: start_bg_at?.substring(0, 10),
      finish_bg_at: finish_bg_at?.substring(0, 10),
    });
  }, [applicationFormValues, formChange]);

  function changeActiveCard(value: string) {
    setActiveCard(value);
  }

  function FunChengeComponentMatchCompRequest<
    T extends { title: string; MATCH_DATA: string },
  >(item: T) {
    if (item.MATCH_DATA === "CHAT") {
      dispatch(
        UP_DATE_IS_NEW_MESSAGE({ id: Number(id) ?? 0, isNewMessage: false }),
      );
    }
    changeActiveCard(item.MATCH_DATA);
    setTitleMatchCompRequest(item.title);
    dispatch(SWAP_MATCH_DATA_REQUEST(item.MATCH_DATA));
  }

  function setTitleHandlerClick(item: ReactNode) {
    setTitleMatchCompRequest(item);
  }

  async function changeApplicationStatus(data_id: number, data_type: string) {
    const newStatus = await changeStatus({
      app_id: data_id,
      type: data_type,
    });

    if ("error" in newStatus) {
      message.error("Произошла ошибка");
    } else if ("data" in newStatus) {
      const { data } = newStatus;
      if (id && data) {
        dispatch(UP_DATE_APPLICATION_STATUS({ id: +id, status: data.data }));
      }
    }
  }

  function handleCancel() {
    setModalVisible(false);
  }

  async function onFinishModalForm(values: { banks: number[] }) {
    if (values.banks) {
      const newBanks = await addBanks({
        bank_id: values.banks,
        app_id: data?.id,
      });
      if ("data" in newBanks) {
        dispatch(ADD_NEW_BANK({ banks: newBanks.data, id: data?.id }));
      }
    }

    setTimeout(() => {
      formModal.resetFields();
      handleCancel();
    }, 1000);
    if (addError) {
      message.error("Произошла ошибка");
    }
  }

  function showModalStatus() {
    setIsModalStatus(true);
  }

  function handleModalStatusOk(data_id: number, data_type: string) {
    changeApplicationStatus(data_id, data_type);
    setIsModalStatus(false);
  }

  function handleModalStatusCancel() {
    setIsModalStatus(false);
  }

  function onClickModalStatus(type: string, title: string) {
    setChangingStatus({ type: type, title: title });
    showModalStatus();
  }

  function stopIsLoadingEdit() {
    setTimeout(() => {
      setIsLoadingArray({
        isLoadingEdit: false,
        isLoadingEditAndToInWork: false,
      });
    }, 1000);
  }

  function changeApplication(addToInWork: boolean) {
    if (id) {
      formChange.submit();
      const formValues = formChange.getFieldsValue(true);
      const banks = formModalAddPreferredBanks.getFieldValue("banks");

      setIsLoadingArray((prev) => {
        const changeValue = addToInWork
          ? { isLoadingEditAndToInWork: true }
          : { isLoadingEdit: true };
        return { ...prev, ...changeValue };
      });

      try {
        const start_bg_at = dayjs(formValues.start_bg_at);
        const finish_bg_at = dayjs(formValues?.finish_bg_at);

        if (!start_bg_at.isValid() || !finish_bg_at.isValid()) {
          message.error("Некорректный ввод даты окончания или начала БГ");
        } else {
          editApplication({
            ...formValues,
            start_bg_at: start_bg_at.format("YYYY-MM-DD"),
            finish_bg_at: finish_bg_at.format("YYYY-MM-DD"),
            app_id: +id,
            banks,
          });
        }

        if (addToInWork) {
          changeStatus({ app_id: +id, type: "new_application" });
          dispatch(
            UP_DATE_APPLICATION_STATUS({
              id: +id,
              status: {
                color: "blue",
                id: 1,
                info: "Есть незаполненые поля",
                info_color: "info",
                title: "Новая заявка",
                type: "new_application",
              },
            }),
          );
        }
      } catch {
        message.error("Произошла ошибка");
      } finally {
        stopIsLoadingEdit();
      }
    }
  }

  function changeModalVisible(value: boolean) {
    setModalVisible(value);
  }

  const ConstructorAplicationButton: IConstructorAplicationButton = {
    NEW_APPLICATION: [buttonConfigs.inWork],
    IN_WORK: [
      buttonConfigs.approve,
      buttonConfigs.forRevision,
      buttonConfigs.rejectBank,
    ],
    REJECTED_BANK: [buttonConfigs.forRevision],
    REJECTED_CLIENT: [buttonConfigs.forRevision],
    FOR_REVISION: [buttonConfigs.inWork, buttonConfigs.rejectBank],
    ISSUED: [buttonConfigs.inWork],
    OFFER: [
      buttonConfigs.approve,
      buttonConfigs.forRevision,
      buttonConfigs.rejectBank,
    ],
    ADD_BANK: [buttonConfigs.addBank],
  };

  /* Если с бэка не приходит messages - скрываем чат */
  let filteredInfoCard = [];
  if (!data.messages || data.status_id === APPLICATION_STATUS_ID.STATUS_DRAFT) {
    filteredInfoCard = infoCard.filter(
      (cardItem) => cardItem.MATCH_DATA !== "CHAT",
    );
  } else {
    filteredInfoCard = infoCard;
  }

  const [archiveBank] = useApplicationBankArchiveMutation();

  async function toogleArchive(
    app_id: number,
    bank_id: number,
    is_enabled: boolean,
  ) {
    try {
      await archiveBank({
        bank_id: bank_id,
        is_enabled: !is_enabled,
        app_id: app_id,
      }).unwrap();
    } catch {
      message.error("Произошла ошибка");
    }
  }

  const enableSignButton =
    bankStatusesForSign.includes(activeBankInfo?.status?.type) &&
    MATCH_RENDERS === MATCH_DATA_APPLICATION_RENDER.BANK_CLIENT;

  const sortApplicationBanks = [...application_banks].sort((a, b) => {
    if (!a.is_enabled && b.is_enabled) {
      return 1;
    }

    if (a.is_enabled && !b.is_enabled) {
      return -1;
    }

    const firstPriority = a.status?.priority ?? 0;
    const secondPriority = b.status?.priority ?? 0;

    return secondPriority - firstPriority;
  });

  return (
    <>
      <Spin spinning={isLoading} size="large">
        <div className={classes.applicationContainer}>
          <div className={classes.applicationLeftContainer}>
            <div className={classes.applicationTitleContainer}>
              <UI_ITOModuleTitle title={`Заявка № ${data?.id}`} />
              <Tag color={data?.status.color}>{data?.status.title}</Tag>
            </div>

            <div className={classes.tabContainer}>
              {filteredInfoCard.map((item) => {
                const { title, MATCH_DATA } = item;
                const dataMatch = { title, MATCH_DATA };
                return (
                  MATCH_DATA !== "BANK_CREDIT" && (
                    <UI_ModuleTitleCard
                      isActive={activeCard === item.MATCH_DATA}
                      key={MATCH_DATA}
                      title={item.title}
                      iconAdditional={item.icon}
                      onClick={() =>
                        FunChengeComponentMatchCompRequest(dataMatch)
                      }
                    />
                  )
                );
              })}
            </div>

            <div className={classes.moduleTitleCardWrapper}>
              {filteredInfoCard.map((item) => {
                const id = item.MATCH_DATA;
                const { MATCH_DATA } = item;
                return (
                  MATCH_DATA === "BANK_CREDIT" && (
                    <Guard.Role key={id} roles={[USER.SUPPORT_CREDIT]}>
                      <div header-level="1" key={id}>
                        {STATUS_TYPE !== "draft" && (
                          <UI_ITOModuleSubTitle
                            title={`Заявка направлена в ${
                              application_banks?.length
                            } ${plural(application_banks?.length, {
                              one: "банк",
                              few: "банка",
                              many: "банков",
                            })}`}
                          />
                        )}
                      </div>

                      <div className={classes.bankListContainer}>
                        <Guard.ApplicationStatus
                          allowedStatuses={[
                            STATUS_APPLICATION.IN_WORK,
                            STATUS_APPLICATION.NEW_APPLICATION,
                            STATUS_APPLICATION.TO_REWORK,
                            STATUS_APPLICATION.OFFER,
                          ]}
                        >
                          {preferedBanks && preferedBanks.length !== 0 && (
                            <BankListInApplicationInfoModal
                              preferedBanks={preferedBanks}
                              alertTitle="Агент выбрал предпочтительные для отправки банки."
                            />
                          )}
                        </Guard.ApplicationStatus>

                        {sortApplicationBanks.map((el) => {
                          return (
                            <>
                              <ApplicationBankCard
                                onShow={() => {
                                  dispatch(
                                    SWAP_MATCH_DATA_REQUEST_BANK_ID({
                                      id: el.id,
                                      value:
                                        MATCH_DATA_APPLICATION_RENDER.BANK_CREDIT,
                                    }),
                                  );
                                }}
                                bankName={el.bank.title}
                                status={el.status}
                                key={el?.id}
                                isActive={
                                  el?.id === activeBankInfo?.id &&
                                  MATCH_RENDERS ===
                                    MATCH_DATA_APPLICATION_RENDER.BANK_CREDIT
                                }
                                childrenContainerProps={{
                                  className:
                                    classes.bankCreditCardChildContainer,
                                }}
                              >
                                <Button
                                  variant="link"
                                  color="primary"
                                  onClick={() => {
                                    toogleArchive(
                                      el.application_id,
                                      el.bank_id,
                                      el.is_enabled,
                                    );
                                  }}
                                  icon={
                                    el.is_enabled ? (
                                      <EyeOutlined />
                                    ) : (
                                      <EyeInvisibleOutlined />
                                    )
                                  }
                                ></Button>
                              </ApplicationBankCard>
                            </>
                          );
                        })}
                      </div>
                    </Guard.Role>
                  )
                );
              })}
            </div>

            <Guard.Role
              roles={[USER.AGENT_SIMPLE, USER.CLIENT_SIMPLE, USER.MANAGER]}
            >
              <div className={classes.moduleTitleCardWrapper}>
                {STATUS_TYPE !== "draft" && (
                  <HocUiModuleCardBanks
                    setTitleBank={setTitleHandlerClick}
                    activeCard={activeCard}
                    changeActiveCard={changeActiveCard}
                  />
                )}

                <Guard.ApplicationStatus
                  allowedStatuses={[STATUS_APPLICATION.DRAFT]}
                >
                  <Form
                    name={"modalAddPreferredBanks"}
                    form={formModalAddPreferredBanks}
                    layout="vertical"
                    initialValues={{
                      allBanks: preferedBanks?.length < 0,
                    }}
                  >
                    <BankCheckBoxesList checkedBanksInitial={preferedBanks} />
                  </Form>
                </Guard.ApplicationStatus>
              </div>
            </Guard.Role>
          </div>
          {/* Компонент для изменения правых табов матчингом */}
          <MatchCompRequest
            title={titleMatchCompRequest}
            formChange={formChange}
          />
        </div>
      </Spin>
      <UIModuleStikeController>
        <Guard.Role roles={[USER.SUPPORT_CREDIT]}>
          {STATUS_TYPE !== STATUS_APPLICATION.ISSUED &&
            STATUS_TYPE !== STATUS_APPLICATION.APPROVED && (
              <ButtonGroupStatus
                buttonConfig={ConstructorAplicationButton["ADD_BANK"]}
                changeModalVisible={changeModalVisible}
                modalVisible={modalVisible}
                onClickModalStatus={onClickModalStatus}
              />
            )}

          <ButtonGroupStatus
            buttonConfig={ConstructorAplicationButton[buttonType]}
            changeModalVisible={changeModalVisible}
            modalVisible={modalVisible}
            onClickModalStatus={onClickModalStatus}
          />
          <BankModalList
            isModalOpen={modalVisible}
            handleCancel={handleCancel}
            handleOk={() => formModal.submit()}
            okButtonProps={{
              loading: addBankLoading,
              disabled: addBankLoading,
            }}
          >
            <>
              <Form
                name={"modalForm"}
                form={formModal}
                layout="vertical"
                onFinish={onFinishModalForm}
              >
                <Form.Item name="banks">
                  <Checkbox.Group>
                    <div className={classes.pageApplicationBankListContainer}>
                      {sortByKey(Array.from(banks), "title")?.map((bank) => {
                        if (bank.is_enabled) {
                          return (
                            <Checkbox
                              value={bank?.id}
                              style={{ marginRight: "10px" }}
                              className={classes.checkBoxBank}
                              key={bank.id}
                            >
                              {bank?.title}
                            </Checkbox>
                          );
                        }
                      })}
                    </div>
                  </Checkbox.Group>
                </Form.Item>
              </Form>
            </>
          </BankModalList>
        </Guard.Role>

        <Guard.Role
          roles={[USER.AGENT_SIMPLE, USER.CLIENT_SIMPLE, USER.SUPPORT_CREDIT]}
        >
          <Guard.ApplicationStatus allowedStatuses={[STATUS_APPLICATION.DRAFT]}>
            <DraftButtons
              isSuccessEdit={isSuccessEdit}
              isLoadingArray={isLoadingArray}
              changeApplication={changeApplication}
              isPassportNotIncludes={isPassportNotIncludes}
            />
          </Guard.ApplicationStatus>
        </Guard.Role>

        <Guard.Role roles={[USER.AGENT_SIMPLE, USER.CLIENT_SIMPLE]}>
          <Guard.ApplicationStatus
            allowedStatuses={[
              STATUS_APPLICATION.REQUIRED_SIGNATURE,
              STATUS_APPLICATION.IN_WORK,
              STATUS_APPLICATION.ISSUED,
              STATUS_APPLICATION.NEW_APPLICATION,
              STATUS_APPLICATION.OFFER,
              STATUS_APPLICATION.TO_REWORK,
            ]}
          >
            <div className={classes.pageApplicationButtonReject}>
              <ButtonGroupStatus
                buttonConfig={[buttonConfigs.rejectClient]}
                changeModalVisible={changeModalVisible}
                modalVisible={modalVisible}
                onClickModalStatus={onClickModalStatus}
              >
                {enableSignButton && (
                  <DocumentsSignModalButton
                    applicationBankId={bankData?.id}
                    applicationId={bankData?.application_id}
                  />
                )}
              </ButtonGroupStatus>
            </div>
          </Guard.ApplicationStatus>
        </Guard.Role>

        <Modal
          title="Изменить статус заявки"
          open={isModalStatus}
          onOk={() => handleModalStatusOk(data?.id, changingStatus?.type)}
          onCancel={handleModalStatusCancel}
        >
          Изменить статус заявки на: <strong>{changingStatus?.title}</strong>?
        </Modal>

        {activeBankInfo && (
          <Guard.Role roles={[USER.CLIENT_SIMPLE]}>
            <Guard.ApplicationBankStatus
              status={activeBankInfo.status}
              allowedStatuses={[
                {
                  bank_name: BANK_NAME.KKB,
                  type: APPLICATION_BANK_STATUS_KKB.SIGNING,
                },
                {
                  bank_name: BANK_NAME.KKB,
                  type: APPLICATION_BANK_STATUS_KKB.RESIGNING,
                },
                {
                  bank_name: BANK_NAME.KKB,
                  type: APPLICATION_BANK_STATUS_KKB.SIGNATURE_REQUIRED,
                },
              ]}
            >
              <DocumentsSignModalButton
                applicationBankId={bankData?.id}
                applicationId={bankData?.application_id}
              />
            </Guard.ApplicationBankStatus>
          </Guard.Role>
        )}
      </UIModuleStikeController>
    </>
  );
}
